export default __webpack_public_path__ + "static/office2-1x-673903b4435984eaa518187b2d8d8a6d.jpg";